export default "__VITE_ASSET__Bltgsafp__"